import React, { useCallback, useState, useMemo } from 'react';
import { Button, Modal, ModalBody, ModalHeader, Nav, NavItem, NavLink, Col, FormInput, InputGroup, InputGroupAddon, InputGroupText, FormSelect, ModalFooter } from 'shards-react';
import { connect } from 'react-redux';
import { updateAdditionalData } from '../../utils/redux/actions';

const AdditionalData = ({ dispatch, mainModuleData, additionalTabs, additionalFields, approved }) => {
	const [activeTab, setActiveTab] = useState();
	const [togglemodal, setTogglemodal] = useState(false);
	const [scrollButtons, setScrollButtons] = useState();
	const [localData, setLocalData] = useState();

	const tabsData = useCallback(() => {
		if (!Array.isArray(additionalTabs)) return {};

		const reducer = (obj, tabName) => {
			const isValueExist = additionalFields && additionalFields[tabName];
			return {
				...obj,
				[tabName]: isValueExist ? additionalFields[tabName] : {},
			};
		};

		return additionalTabs.reduce(reducer, {});
	}, [additionalFields, additionalTabs]);

	const updateActiveTab = (e, newValue) => {
		e.target.scrollIntoView({
			inline: e.target.offsetWidth < e.target.offsetParent.offsetWidth ? 'center' : 'start',
			behavior: 'smooth',
		});
		setActiveTab(newValue);
	};

	const scrolNav = (e, increment) => {
		const overflownElement = document.querySelector('#additional-data .overflow-hidden');
		overflownElement.scrollLeft = overflownElement.scrollLeft + (increment ? 200 : -200);
	};

	const closeModal = () => {
		setActiveTab(additionalTabs[0]);
		setTogglemodal((oldState) => !oldState);
	};

	const toggleAdditionalData = useCallback(() => {
		setActiveTab(additionalTabs[0]);
		setLocalData(tabsData);
		setTogglemodal(true);
	}, [additionalTabs, tabsData]);

	const toggleButtonContent = useMemo(
		() => (
			<>
				<i className='fas fa-info align-middle' style={{ fontSize: 'initial' }} />
				<span className='align-middle ml-2 d-none d-md-inline'>Zusätzliche Information</span>
			</>
		),
		[]
	);

	return (
		<>
			{togglemodal && (
				<Modal
					id='additional-data'
					centered
					open={togglemodal}
					toggle={() => null}
					showModal={() => {
						if (additionalTabs.length) {
							const overflownElement = document.querySelector('#additional-data .overflow-hidden');
							setScrollButtons({
								right: overflownElement.scrollLeft + overflownElement.offsetWidth !== overflownElement.scrollWidth,
								left: overflownElement.scrollLeft > 0,
							});
						}
					}}
				>
					<ModalHeader
						className='p-0'
						titleClass='position-relative'
						tag={'div'}
						style={{ height: '46px' }}
						toggle={() => {
							setActiveTab(additionalTabs[0]);
							setTogglemodal((oldState) => !oldState);
						}}
					>
						{scrollButtons && scrollButtons.left && (
							<Button
								className='position-absolute h-100 border-0 text-dark'
								theme='warning'
								outline
								squared
								onClick={(e) => scrolNav(e, false)}
								style={{
									display: 'none',
									outline: 0,
									left: 0,
									zIndex: 1,
									borderTopLeftRadius: '0.375rem',
									backgroundImage: 'linear-gradient(to right, #0299B4, transparent)',
								}}
							>
								<i className='fas fa-chevron-left' />
							</Button>
						)}
						<Col
							className='p-0 overflow-hidden rounded-top'
							onScroll={(e) => {
								e.persist();
								setScrollButtons({
									right: e.target.scrollLeft + e.target.offsetWidth !== e.target.scrollWidth,
									left: e.target.scrollLeft > 0,
								});
							}}
						>
							<Nav tabs style={{ width: 'max-content' }}>
								{additionalTabs.map((tabName, index) => {
									const statusIcon = Object.values(mainModuleData[tabName]).filter(({ displayName, type, options }) => {
										if (type === 'text') return !localData[tabName][displayName];

										return !options.includes(localData[tabName][displayName]);
									}).length;

									return (
										<NavItem key={index}>
											<NavLink tag={'div'} className='tab-text pointer' active={tabName === activeTab} onClick={(e) => updateActiveTab(e, tabName)}>
												<i className={`mr-2 ${statusIcon === 0 ? 'fas fa-check-circle text-success' : 'fas fa-exclamation-circle text-danger'}`} />
												{tabName}
											</NavLink>
										</NavItem>
									);
								})}
							</Nav>
						</Col>
						{scrollButtons && scrollButtons.right && (
							<Button
								className='position-absolute h-100 border-0 text-dark'
								theme='warning'
								squared
								outline
								onClick={(e) => scrolNav(e, true)}
								style={{
									display: 'none',
									outline: 0,
									right: 0,
									zIndex: 1,
									backgroundImage: 'linear-gradient(to left, #0299B4, transparent)',
									borderTopRightRadius: '0.375rem',
								}}
							>
								<i className='fas fa-chevron-right' />
							</Button>
						)}
					</ModalHeader>
					<ModalBody className='p-3'>
						{Object.values(mainModuleData[activeTab]).map((field, index) => {
							const fieldValue = localData[activeTab][field.displayName];

							const isValid = (fieldValue && field.type === 'text') || (fieldValue && field.type === 'dropdown' && field.options.includes(fieldValue)) ? { valid: true } : { invalid: true };

							return (
								<InputGroup className='mb-2' key={index}>
									<InputGroupAddon type='prepend'>
										<InputGroupText className='text-dark font-weight-bold'>{field.displayName}</InputGroupText>
									</InputGroupAddon>

									{field.type === 'text' && (
										<FormInput
											placeholder='Bitte eingeben'
											value={fieldValue ? fieldValue : ''}
											disabled={approved}
											{...isValid}
											onChange={(e) => {
												e.persist();
												setLocalData((oldState) => {
													return {
														...oldState,
														[activeTab]: {
															...oldState[activeTab],
															[field.displayName]: e.target.value,
														},
													};
												});
											}}
										/>
									)}
									{field.type === 'dropdown' && !approved && (
										<FormSelect
											value={fieldValue && field.options.includes(fieldValue) ? fieldValue : ''}
											{...isValid}
											onChange={(e) => {
												e.persist();
												setLocalData((oldState) => {
													return {
														...oldState,
														[activeTab]: {
															...oldState[activeTab],
															[field.displayName]: e.target.value,
														},
													};
												});
											}}
										>
											<option disabled value='' className='font-weight-bold'>
												Bitte auswählen...
											</option>
											{field.options &&
												field.options.map((option, index) => (
													<option key={index} value={option}>
														{option}
													</option>
												))}
										</FormSelect>
									)}
									{field.type === 'dropdown' && approved && <FormInput defaultValue={fieldValue} disabled {...isValid} />}
								</InputGroup>
							);
						})}
					</ModalBody>
					{additionalTabs.length > 0 && !approved && (
						<ModalFooter className='justify-content-end p-1'>
							<Button theme='danger' onClick={closeModal}>
								Abbrechen
							</Button>
							<Button
								theme='success'
								onClick={() => {
									dispatch(updateAdditionalData(localData));
									closeModal();
								}}
							>
								Speichern
							</Button>
						</ModalFooter>
					)}
				</Modal>
			)}
			<Button id='additional-data-button' outline theme='warning' pill onClick={toggleAdditionalData}>
				{toggleButtonContent}
			</Button>
		</>
	);
};

/**
 * Take the id of saved in redux document and return it
 * in components props.
 */
const mapStateToProps = (state) => {
	const { additionalFields, additionalTabs, approved } = state.savedDocument;

	return {
		additionalTabs,
		additionalFields,
		approved,
	};
};

export default connect(mapStateToProps)(AdditionalData); //Export component and connect it with redux.
